import StyledParagraph from './StyledParagraph';

export default StyledParagraph;
